import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetBonusHistoryList = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_HISTORY_BONUSES
            });
            if (data.status === 'success') {
                if (params.bonuses) {
                    dispatch(Action.SetGetBonusHistoryListAction({
                        data: data.data,
                        countPage: data.countPage
                    }));
                } else {
                    const bonuses = [...getState().historyMobile.bonuses.data];
                    bonuses.push(data.data);
                    dispatch(Action.SetGetBonusHistoryListAction({
                        data: bonuses.flat(1),
                        countPage: data.countPage
                    }));
                }
                dispatch(Action.SetLoadingAction(false))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetBonusHistoryList as SetGetBonusHistoryList
}